<template>
  <!-- Tablero de control -->
  <v-form ref="form" autocomplete="off">
    <v-row>
      <!--Tipo de Seguro-->
      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          v-model="editedItem.TipoSeguro"
          :items="ArrayTipoSeguro"
          :item-title="
            (ArrayTipoSeguro) =>
              ArrayTipoSeguro.Valor + '-' + ArrayTipoSeguro.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Tipo de Seguro :"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          :clearable="clearcampos.TipoSeguro"
          :readonly="readcampos.TipoSeguro"
        >
        </v-autocomplete>
      </v-col>
      <!--Póliza-->
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="editedItem.Poliza"
          label="Póliza"
          hint="Digite Información"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          :clearable="clearcampos.Poliza"
          :readonly="readcampos.Poliza"
        >
        </v-text-field>
      </v-col>
      <!--Anexo-->
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="editedItem.Anexo"
          label="Anexo:"
          hint="Digite Información"
          dense
          :clearable="clearcampos.Anexo"
          :readonly="readcampos.Anexo"
        >
        </v-text-field>
      </v-col>
      <!--Garantia-->
      <v-col cols="12" sm="4" md="6">
        <v-text-field
          v-model="editedItem.GarantiaID"
          label="Garantia"
          hint="Digite Información"
          dense
          clearable
        >
        </v-text-field>
      </v-col>
      <!--Descripción de seguro-->
      <v-col cols="12" sm="4" md="6">
        <v-text-field
          v-model="editedItem.Descripcion"
          label="Descripción de seguro"
          hint="Digite Información"
          dense
          clearable
        >
        </v-text-field>
      </v-col>
      <!--Estado de póliza-->
      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          v-model="editedItem.EstadoPoliza"
          :items="ArrayEstado"
          :item-title="
            (ArrayEstado) => ArrayEstado.Valor + '-' + ArrayEstado.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Estado de póliza:"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <!--Tipo de póliza-->
      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          v-model="editedItem.TipoPoliza"
          :items="ArrayTipoPoliza"
          :item-title="
            (ArrayTipoPoliza) =>
              ArrayTipoPoliza.Valor + '-' + ArrayTipoPoliza.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Tipo de póliza:"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <!--Clase de póliza-->
      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          v-model="editedItem.ClasePoliza"
          :items="ArrayClasePoliza"
          :item-title="
            (ArrayClasePoliza) =>
              ArrayClasePoliza.Valor + '-' + ArrayClasePoliza.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Clase de póliza:"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <!--Fecha Inicial-->
      <v-col cols="12" sm="12" md="6">
        <v-text-field
          v-model="editedItem.FechaInicial"
          label="Fecha Inicial:"
          type="date"
          clearable
          :update:modelValue="ChangeFechaInicial()"
          :rules="[(v) => !!v || 'Campo obligatorio']"
        ></v-text-field>
      </v-col>
      <!--Fecha Vencimiento -->
      <v-col cols="12" sm="12" md="6">
        <v-text-field
          v-model="editedItem.FechaFinal"
          label="Fecha Vencimiento:"
          type="date"
          clearable
          :min="editedItem.FechaInicial"
          :rules="[(v) => !!v || 'Campo obligatorio']"
        ></v-text-field>
      </v-col>
      <!--Moneda -->
      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          v-model="editedItem.CodMoneda"
          :items="ArrayDesMoneda"
          :item-title="
            (ArrayDesMoneda) =>
              ArrayDesMoneda.CodMonedaId +
              '-' +
              ArrayDesMoneda.Sigla +
              '-' +
              ArrayDesMoneda.Descripcion
          "
          item-value="CodMonedaId"
          color="primary"
          label="Moneda :"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <!--Valor Asegurado-->
      <v-col cols="12" sm="6" md="4">
        <v-text-field
          v-model="editedItem.ValorAsegurado"
          label="Valor Asegurado :"
          v-on:keypress="isNumber()"
          hint="Digite Información"
          dense
          clearable
          maxlength="18"
          counter="18"
          :rules="[(v) => !!v || 'Campo obligatorio']"
        >
        </v-text-field>
      </v-col>
      <!--Valor Prima -->
      <v-col cols="12" sm="6" md="4">
        <v-text-field
          v-model="editedItem.ValorPrima"
          label="Valor Prima :"
          v-on:keypress="isNumber()"
          hint="Digite Información"
          dense
          clearable
          maxlength="18"
          counter="18"
          :rules="[(v) => !!v || 'Campo obligatorio']"
        >
        </v-text-field>
      </v-col>
      <!--Datos de la Aseguradora-->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.TypeDocumentIDAseguradora"
          :items="ArrayAseguradora"
          :item-title="
            (ArrayAseguradora) =>
              ArrayAseguradora.DocumentID +
              '-' +
              ArrayAseguradora.Nombre
          "
          :item-value="
            (ArrayAseguradora) =>
              ArrayAseguradora.TypeDocumentID +
              '&' +
              ArrayAseguradora.DocumentID
          "
          color="primary"
          label="Datos de la Aseguradora :"
          dense
          clearable
          :rules="[(v) => !!v || 'Campo obligatorio']"
        >
        </v-autocomplete>
      </v-col>
      <!--Datos del corredor-->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.TypeDocumentIDCorredor"
          :items="ArrayCorredor"
          :item-title="
            (ArrayCorredor) =>
              ArrayCorredor.TypeDocument_ID +
              '-' +
              ArrayCorredor.Document_ID +
              '-' +
              ArrayCorredor.Nombre
          "
          :item-value="
            (ArrayCorredor) =>
              ArrayCorredor.TypeDocument_ID + '&' + ArrayCorredor.Document_ID
          "
          color="primary"
          label="Datos del corredor :"
          dense
        >
        </v-autocomplete>
      </v-col>
      <!--Forma de pago-->
      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          v-model="editedItem.FormaPago"
          :items="ArrayFormaPago"
          :item-title="
            (ArrayFormaPago) =>
              ArrayFormaPago.Valor + '-' + ArrayFormaPago.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Forma de pago:"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <!--Periocidad de pago-->
      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          v-model="editedItem.PeriodicidadPago"
          :items="ArrayPeriocidad"
          :item-title="
            (ArrayPeriocidad) =>
              ArrayPeriocidad.Valor + '-' + ArrayPeriocidad.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Periocidad de pago:"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <!--Fecha Próximo Pago-->
      <v-col v-if="editedItem.PeriodicidadPago == 'M'" cols="12" sm="6" md="4">
        <v-text-field
          v-model="editedItem.FechaProximoPago"
          label="Fecha próximo pago:"
          type="date"
          clearable
          :rules="[(v) => !!v || 'Campo obligatorio']"
        ></v-text-field>
      </v-col>
      <!--Fecha último pago póliza-->
      <v-col cols="12" sm="6" md="4">
        <v-text-field
          v-model="editedItem.FechaUltimoPago"
          label="Fecha último pago póliza:"
          type="date"
          clearable
        ></v-text-field>
      </v-col>
      <!--Fecha Emisión-->
      <v-col cols="12" sm="6" md="4">
        <v-text-field
          v-model="editedItem.FechaEmision"
          label="Fecha Emisión:"
          type="date"
          clearable
        ></v-text-field>
      </v-col>
      <!--Fecha Hasta Pago-->
      <v-col cols="12" sm="6" md="4">
        <v-text-field
          v-model="editedItem.FechaHastaPago"
          label="Fecha hasta donde fue pagado:"
          type="date"
          clearable
        ></v-text-field>
      </v-col>
      <!--Periodos Mora 
      <v-col cols="12" sm="6" md="4">
        <v-text-field
          v-model="editedItem.PeriodosMora"
          label="Periocidad en mora :"
          v-on:keypress="isNumber()"
          hint="Digite Información"
          dense
          clearable
          maxlength="18"
          counter="18"
        >
        </v-text-field>
      </v-col>-->
      <!--Valor Mora
      <v-col cols="12" sm="6" md="4">
        <v-text-field
          v-model="editedItem.ValorMora"
          label="Valor Mora:"
          v-on:keypress="isNumber()"
          hint="Digite Información"
          dense
          clearable
          maxlength="18"
          counter="18"
        >
        </v-text-field> 
      </v-col>-->
    </v-row>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span
          >Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span
        >
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn
        size="x-large"
        v-if="!buttonSave"
        color="green"
        text
        @click="ValidateCampos"
      >
        Guardar
      </v-btn>
    </div>
  </v-form>
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "seguros_registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    infollaves: {
      type: Object,
      default: null,
      Description: "Información de llaves",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "LLamado a Página Iframe",
    },
    componenteview: {
      type: Number,
      default: 0,
      Description: "Saber a que página llamar",
    },
    iconodialogbtn: {
      type: String,
      default: null,
      Description: "Información icono iframe",
    },
    titledialogbtn: {
      type: String,
      default: null,
      Description: "Información titulo iframe",
    },
    Exito: {
      type: String,
      default: null,
      Description: "Información de respuesta post o put",
    },
    TipoSeguro: {
      type: String,
      default: null,
      Description: "Información de Tipo de seguro",
    },
  },
  data() {
    return {
      progreso: false,
      componenteview: 0,
      buttonSave: false,
      editedItem: {
        SeguroID: null,
        TipoDocumentoID: null,
        DocumentoID: null,
        ContratoID: null,
        Ref1: null,
        TipoSeguro: null,
        Poliza: null,
        Anexo: null,
        GarantiaID: null,
        Descripcion: null,
        EstadoPoliza: null,
        TipoPoliza: null,
        ClasePoliza: null,
        TypeDocumentIDAseguradora: null,
        DocumentIDAseguradora: null,
        TypeDocumentIDCorredor: null,
        DocumentIDCorredor: null,
        FechaInicial: null,
        FechaFinal: null,
        CodMoneda: null,
        ValorAsegurado: null,
        ValorPrima: null,
        FormaPago: null,
        PeriodicidadPago: null,
        FechaUltimoPago: null,
        PeriodosMora: null,
        ValorMora: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
        FechaEmision: null,
        FechaHastaPago: null,
        FechaProximoPago: null,
      },
      defaultItem: {
        SeguroID: null,
        TipoDocumentoID: null,
        DocumentoID: null,
        ContratoID: null,
        Ref1: null,
        TipoSeguro: null,
        Poliza: null,
        Anexo: null,
        GarantiaID: null,
        Descripcion: null,
        EstadoPoliza: null,
        TipoPoliza: null,
        ClasePoliza: null,
        TypeDocumentIDAseguradora: null,
        DocumentIDAseguradora: null,
        TypeDocumentIDCorredor: null,
        DocumentIDCorredor: null,
        FechaInicial: null,
        FechaFinal: null,
        CodMoneda: null,
        ValorAsegurado: null,
        ValorPrima: null,
        FormaPago: null,
        PeriodicidadPago: null,
        FechaUltimoPago: null,
        PeriodosMora: null,
        ValorMora: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
        FechaEmision: null,
        FechaHastaPago: null,
        FechaProximoPago: null,
      },
      clearcampos: {
        TipoSeguro: true,
        Poliza: true,
        Anexo: true,
      },
      readcampos: {
        TipoSeguro: false,
        Poliza: false,
        Anexo: false,
      },
      ArrayTipoSeguro: [],
      ArrayEstado: [],
      ArrayClasePoliza: [],
      ArrayTipoPoliza: [],
      ArrayFormaPago: [],
      ArrayPeriocidad: [],
      ArrayAseguradora: [],
      ArrayCorredor: [],
      ArrayDesMoneda: [],
      wfechainicial: null,
    };
  },
  methods: {
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      if (
        this.editedItem.TipoDocumentoID == "" ||
        this.editedItem.TipoDocumentoID == null ||
        this.editedItem.DocumentoID == "" ||
        this.editedItem.DocumentoID == null ||
        this.editedItem.TipoSeguro == "" ||
        this.editedItem.TipoSeguro == null ||
        this.editedItem.EstadoPoliza == "" ||
        this.editedItem.EstadoPoliza == null ||
        this.editedItem.TipoPoliza == "" ||
        this.editedItem.TipoPoliza == null ||
        this.editedItem.ClasePoliza == "" ||
        this.editedItem.ClasePoliza == null ||
        this.editedItem.TypeDocumentIDAseguradora == "" ||
        this.editedItem.TypeDocumentIDAseguradora == null ||
        this.editedItem.FechaInicial == "" ||
        this.editedItem.FechaInicial == null ||
        this.editedItem.FechaFinal == "" ||
        this.editedItem.FechaFinal == null ||
        this.editedItem.CodMoneda == "" ||
        this.editedItem.CodMoneda == null ||
        this.editedItem.ValorAsegurado == "" ||
        this.editedItem.ValorAsegurado == null ||
        this.editedItem.ValorPrima == "" ||
        this.editedItem.ValorPrima == null ||
        this.editedItem.FormaPago == "" ||
        this.editedItem.FormaPago == null ||
        this.editedItem.PeriodicidadPago == "" ||
        this.editedItem.PeriodicidadPago == null
      ) {
        validate = true;
      } else if (
        this.editedItem.PeriodicidadPago == "M" &&
        (this.editedItem.FechaProximoPago == "" ||
          this.editedItem.FechaProximoPago == null)
      ) {
        validate = true;
      }

      // Consultas a Ejecutar
      if (!validate) {
        var userperfil = this.$store.getters.userperfil;
        this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
        this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;
        var NTR = [];
        if (
          this.editedItem.TypeDocumentIDAseguradora != "" &&
          this.editedItem.TypeDocumentIDAseguradora != null
        ) {
          NTR = this.editedItem.TypeDocumentIDAseguradora.split("&");
          this.editedItem.TypeDocumentIDAseguradora = NTR[0];
          this.editedItem.DocumentIDAseguradora = NTR[1];
        }
        if (this.editedIndex != -1) {
          this.putRegistro();
        } else {
          this.postRegistro();
        }
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
      }
    },

    // Crear Registro
    async postRegistro() {
      this.progreso = true;
      this.axios
        .post("/ActivosO/Seguros/Post", this.editedItem)
        .then((result) => {
          this.reset();
          var data = false;
          this.$emit("update:page", data);
          this.$emit("update:Exito", result.data);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },

    // Actualizacion de registro
    async putRegistro() {
      this.progreso = true;
      console.log(this.editedItem)
      this.axios
        .put("/ActivosO/Seguros/Put", this.editedItem)
        .then((response) => {
          this.reset();
          var data = false;
          this.$emit("update:page", data);
          this.$emit("update:Exito", response.data);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },

    // Consulta Aseguradora
    async getAseguradora() {
      this.ArrayAseguradora = [];
      this.axios
        .get("/Personas/Cliente/CD3/2/")
        .then((response) => {
          this.ArrayAseguradora = response.data;
        })
        .catch((e) => console.log(e));
    },

    // Consulta Fecha Inicial
    ChangeFechaInicial() {
      if (this.wfechainicial != this.editedItem.FechaInicial) {
        this.wfechainicial = this.editedItem.FechaInicial;
        if (
          this.editedItem.FechaInicial != "" &&
          this.editedItem.FechaInicial != null &&
          this.editedIndex == -1
        ) {
          var fecha = new Date(this.editedItem.FechaInicial);
          var fechasplit = this.editedItem.FechaInicial.split("-");
          var anionew = fecha.getFullYear() + 1;
          this.editedItem.FechaFinal =
            anionew + "-" + fechasplit[1] + "-" + fechasplit[2];
          console.log(this.editedItem.FechaFinal);
        }
      }
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
    },
    // Cargue Combos
    CargueCombos() {
      var arrayTabla = this.$store.getters.MTablaSeleccion;
      this.ArrayTipoSeguro = arrayTabla.filter(
        (item) => item.Valor != null && item.TablaId == 24
      );

      this.ArrayEstado = arrayTabla.filter(
        (item) => item.Valor != null && item.TablaId == 25
      );

      this.ArrayTipoPoliza = arrayTabla.filter(
        (item) => item.Valor != null && item.TablaId == 26
      );

      this.ArrayClasePoliza = arrayTabla.filter(
        (item) => item.Valor != null && item.TablaId == 27
      );
      var Moneda = this.$store.getters.MDescMoneda;
      this.ArrayDesMoneda = Moneda.filter((item) => item.CodMonedaId != 0);

      this.ArrayFormaPago = arrayTabla.filter(
        (item) => item.Valor != null && item.TablaId == 28
      );

      this.ArrayPeriocidad = arrayTabla.filter(
        (item) => item.Valor != null && item.TablaId == 29
      );
      this.getAseguradora();
    },
    // Actualizar carga
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.editedItem = this.infoedit;
        this.clearcampos.TipoSeguro = false;
        this.readcampos.TipoSeguro = true;
        this.clearcampos.Poliza = false;
        this.readcampos.Poliza = true;
        this.clearcampos.Anexo = false;
        this.readcampos.Anexo = true;
      } else {
        this.clearcampos.TipoSeguro = true;
        this.readcampos.TipoSeguro = false;
        this.clearcampos.Poliza = true;
        this.readcampos.Poliza = false;
        this.clearcampos.Anexo = true;
        this.readcampos.Anexo = false;
        if (this.TipoSeguro != null && this.TipoSeguro != "") {
          this.clearcampos.TipoSeguro = false;
          this.readcampos.TipoSeguro = true;
          this.editedItem.TipoSeguro = this.TipoSeguro;
        }
      }
      if (
        this.editedItem.TypeDocumentIDAseguradora != null &&
        this.editedItem.TypeDocumentIDAseguradora != 0 &&
        this.editedItem.DocumentIDAseguradora != null &&
        this.editedItem.DocumentIDAseguradora != ""
      ) {
        this.editedItem.TypeDocumentIDAseguradora =
          this.editedItem.TypeDocumentIDAseguradora +
          "&" +
          this.editedItem.DocumentIDAseguradora;
      } else {
        this.editedItem.TypeDocumentIDAseguradora = null;
      }
    },
  },
  mounted() {
    this.CargueCombos();
    this.ActualizarCargue();
    if (this.infollaves != null) {
      this.editedItem.TipoDocumentoID =
        this.infollaves.TypeDocument_ID != null
          ? this.infollaves.TypeDocument_ID
          : null;
      this.editedItem.DocumentoID =
        this.infollaves.Document_ID != null
          ? this.infollaves.Document_ID
          : null;
      this.editedItem.ContratoID =
        this.infollaves.Contrato != null ? this.infollaves.Contrato : null;
      this.editedItem.Ref1 =
        this.infollaves.Ref_1 != null ? this.infollaves.Ref_1 : null;
    }
  },
};
</script>
